<script>
import NavigationHeader from '../NavigationHeader.vue';
import ButtonNormal from '../buttons/ButtonNormal.vue';
import { required } from 'vuelidate/lib/validators';
import Modal from '../shared/Modal.vue';
import AccountService from '@/services/AccountService';
import { getServerSubdomain } from '@/services/Authentication';
import { mapActions, mapGetters } from 'vuex';
import constants from './TariffConstants';
export default {
    name: 'Tariff',
    components: {
        NavigationHeader,
        ButtonNormal,
        Modal
    },
    data() {
        return {
            premiumFeatures: constants.premiumFeatures,
            accountInfo: null,
            isIbanSet: false,
            iban: '',
            isSubmittedPopup: false,
            isModalForTarifChangeVisible: false
        };
    },
    validations: {
        iban: {
            required,
        }
    },
    created() {
        this.getAccount();
    },
    methods: {
        ...mapActions(['setTarif']),
        setPremiumTariff() {
             this.setTarif({ subdomain: getServerSubdomain(), selectedTariff: '2' }).then( resp => {
                 if (resp) {
                    this.$router.push('/');
                    this.$toasted.global.starface_success({
                        message: 'Dein Tarif UP-Grade wurde durchgeführt',
                        icon: 'USER',
                    });
                 } else {
                     this.$toasted.global.starface_error({
                        message: 'Problem mit der Aktivierung des Tarifs.',
                        icon: 'USER',
                    });
                 }
             });
        },
        getAccount() {
            AccountService.getAccount().then(responseAccount => {
                if (responseAccount.data != null) {
                    this.accountInfo = responseAccount.data;
                    this.checkIfIbanIsSet();
                }
            });
        },
        checkIfIbanIsSet() {
            if (this.accountInfo.iban !== '') {
                this.isIbanSet = true;
            }
        },
        confirmModalForTariffChange() {
            if (!this.isIbanSet) {
                this.saveIban();
            }
            if (this.isIbanSet) {
                this.isModalForTarifChangeVisible = false;
                this.setPremiumTariff();
            }
        },
        saveIban() {
            this.isSubmittedPopup = true;
            if (!this.$v.iban.$invalid) {
                this.accountInfo.iban = this.iban;

                AccountService.updateAccount(this.accountInfo).then(responseAccount => {
                    if (responseAccount.data.success != null) {
                        this.isModalForTarifChangeVisible = false;
                        this.getAccount();
                        this.setPremiumTariff();
                    } else {
                        this.$toasted.global.starface_error({
                            message: 'IBAN konnte nicht gespeichert werden. Bitte überprüfe Deine IBAN.',
                            icon: 'USER',
                        });
                    }
                })
                .catch(error => {
                    this.$toasted.global.starface_error({
                        message: 'IBAN konnte nicht gespeichert werden.',
                        icon: 'USER',
                    });
                });
            }

        },
        closeModalForTariffChange() {
            this.isModalForTarifChangeVisible = false;
        },
        openModalForTariffChange() {
            this.isModalForTarifChangeVisible = true;
        }
    }
};
</script>

<template>
    <div class="container">
        <div id="tariff">
            <NavigationHeader route="/" navigationText="Zum Dashboard" title="Tarifwechsel" />
            <div>
                Du benötigst weitere Funktionen? Dann hol Dir jetzt den vollen Funktionsumfang mit STARFACE UP! Ab 7,90 € zzgl. MwSt. monatlich (inkl. 1 Benutzer*) erhältst du alle Funktionen die Du für Dein Unternehmen benötigst! Entscheidest Du Dich für ein UP-Grade, reduzieren wir zusätzlich Deine Telefonie Kosten!
                <div class="tariff-prices">
                    <p>9,9 Cent/Minute statt 18,9 Cent/min zzgl. MwSt. (national Mobilfunk)</p>
                    <p>0,9 Cent/Minute statt 1,9 Cent/Minute zzgl. MwSt. (national Festnetz)</p>
                </div>
            </div>
            <div class="premium-features">
                <div class="premium-feature" v-for="(premiumFeature, index) in premiumFeatures" :key="index">
                    <div class="details-icon">
                        <img src="@/assets/starface_icons_png/24/orange/circle_checked@2x.png" alt="Circle checked">
                    </div> 
                    <div class="feature">
                        <span class="feature-title">{{ premiumFeature.title }}</span>
                        <span class="feature-description">{{ premiumFeature.description }}</span>
                    </div> 
                </div>
            </div>
            <div class="footer">
                <div class="left">
                </div>
                <div class="right">
                    <ButtonNormal @onClick="openModalForTariffChange()" class="btn-save" buttonTitle="weiter"
                                    cssClass="btn btn-primary"/>
                </div>
            </div>
            <div class="footer-footnote">
                <p>*Jeder weitere Benutzer kostet 4,90 € zzgl. MwSt. Tarife & Preise findest du <a style="color:#F59B00;text-decoration: underline;" href="https://starface-up.com/tarifliste-starface-up" target="_blank">hier</a>.</p>
                <p>** Für die Fax Funktion fallen zusätzlich 4,90 € zzgl. MwSt. pro Monat an.</p>
            </div>
        </div>
        <Modal v-show="isModalForTarifChangeVisible" confirmationButtonText="Kostenpflichtig loslegen!" @close="closeModalForTariffChange" @confirm="confirmModalForTariffChange">
            <template slot="header">
                Möchtest Du Dein STARFACE UP-Grade durchführen?
            </template>
            <template slot="body">
                <div class="iban-modal">
                    <form  v-if="!isIbanSet" class="form">
                        <p>Für die Aktivierung benötigen wir Deine Bankverbindung. Bitte trage hier Deine IBAN ein:</p>
                        <div class="form-group form-text iban">
                            <label for="iban">IBAN:</label>
                            <input class="form-control" type="text" name="iban" id="iban"
                                   v-bind:class="{ 'has-error': isSubmittedPopup && $v.iban.$invalid }"
                                   v-model="iban" required/>
                            <span class="error-message" v-if="isSubmittedPopup && $v.iban.$invalid">Bitte gebe Deine IBAN ein.</span>
                        </div>
                    </form>
                    <div class="iban-description">
                        Folgende Kosten erwarten Dich in Zukunft:
                        <ul>
                            <li>Grundgebühr: 7,90 € zzgl. MwSt. (inkl. 1. Benutzer)</li>
                            <li>Benutzer: 4,90 € zzgl. MwSt. pro Benutzer (erst ab 2. Benutzer)</li>
                            <li>Reduzierter Kostentarif: 
                                <ul>
                                    <li>0,9 Cent/Min zzgl. MwSt. (nat. Festnetz) </li>
                                    <li>9,9 Cent/Min zzgl. MwSt. (nat. Mobilfunk)</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
             </template>
        </Modal>
    </div>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
@import '../../assets/scss/forms.scss';
@import '../../assets/scss/grid.scss';
#tariff {
    .tariff-prices {
        padding-top: 32px;
        p {
            padding-bottom: 10px;
            margin:0px;
        }
    }
    .premium-features {
        padding-top: 32px;
        .premium-feature {
            display: grid;
            grid-template-columns: 48px 1fr;
            grid-template-rows: 1fr;
            gap: 0px 0px;
            grid-template-areas: ". .";
            padding-bottom: 24px;
            .details-icon {
                img {
                    width: 32px;
                    height: 32px;
                }
            }
            .feature {
                display: flex;
                flex-direction: column;
                color: $grey-dark;
                font-size: 18px;
                letter-spacing: 0;
                line-height: 24px;
                .feature-title {
                    font-weight: bold;
                    padding-bottom: 8px;
                }
            }
        }
    }
    .footer {
        display: grid;
        display: -ms-grid;
        grid-template-columns: 1fr 1fr;
        -ms-grid-columns: 1fr 1fr;
        .left {
            @extend .grid-column-1;
        }
        .right {
            display: inline-block;
            grid-column: 2;
            -ms-grid-column: 2;
            .btn-cancel {
                max-width: 45%;
                float: right;
                margin-right: 25px;
            }
            .btn-save {
                max-width: 45%;
                float: right;
            }
        }
    }
    .footer-footnote {
        font-size: 16px;
        p {
            padding-bottom: 10px;
            margin: 0px;
        }
    }

}
.iban-modal {
    width: 650px;
}
.sucess-modal {
    /deep/ .modal{
        width: 538px;
        max-height: 550px;
        .modal-body {
            padding: 40px;
            .modal-notification-template {
                padding-bottom: 40px;
                .notification-icon {
                    text-align: center;
                    padding-bottom: 24px;
                }
                .notification-title {
                    font-size: 18px;
                    font-weight: bold;
                    letter-spacing: 0;
                    line-height: 24px;
                    text-align: center;
                    padding-bottom: 10px;
                }
                .notification-description {
                    font-size: 18px;
                    letter-spacing: 0;
                    line-height: 24px;
                    text-align: center;
                }
            }
        }
    }


}
.error-message {
    font-size: 12px;
    font-weight: 600;
    text-align: left;
    color: $red;
}
.has-error {
    border-color: #f54d00;
}
</style>
